
import { z } from "zod";

export const FinancingVendorValues = ["GOODLEAP", "SUNLIGHT", "UPGRADE"] as const;
export const FinancingVendorSchema = z.enum(FinancingVendorValues);
export const FinancingVendor = FinancingVendorSchema.enum;
export type FinancingVendor = (typeof FinancingVendorValues)[number];
export const FinancingVendorDisplayNames = { "GOODLEAP": "Goodleap Financial",
"SUNLIGHT": "Sunlight Financial",
"UPGRADE": "Upgrade Financial", } satisfies Record<FinancingVendor, string>;
